<template>
  <section class="sectionOuterBox" aria-label="Mobile app features for administrators">
    <div class="sectionInnerBox text-left py-12">
      <v-container class="container">
        <v-row>
          <v-col cols="12" md="6">
            <div class="sectionImageContainer">
              <div style="max-width: 600px;" class="mobileImage">
                <img style="width: 100%;" src="https://cdn.planbook.com/images/welcome-mobile-admins.png" alt="">
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="my-auto">
            <h2 class="sectionListHeader md cBlue">{{ $t('mobile.administrators.title') }}</h2>
            <div>
              <ul class="sectionList md pl-0 my-4">
                <li><i class="cBlue fal fa-arrow-circle-right"></i><span>{{ $t('mobile.administrators.feature1') }}</span>
                </li>
                <li><i class="cBlue fal fa-arrow-circle-right"></i><span>{{ $t('mobile.administrators.feature2') }}</span>
                </li>
                <li><i class="cBlue fal fa-arrow-circle-right"></i><span>{{ $t('mobile.administrators.feature3') }}</span>
                </li>
                <li><i class="cBlue fal fa-arrow-circle-right"></i><span>{{ $t('mobile.administrators.feature4') }}</span>
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Administrators extends Vue {
}
</script>

<style lang="scss" scoped></style>
